import type { SurveyDto, UxSignalsSurveyDto } from '@helsenorge/framework-utils/additional-page-content';
import { getSurveysCookie, setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';

import FeedbackPanelWrapper from './FeedBackPanelWrapper';
import UxSignalsWrapper from './UxSignalWrapper';

import styles from './styles.module.scss';

export interface FeedbackPanelContainerProps {
  surveys: SurveyDto[] | UxSignalsSurveyDto[];
}

const FeedbackPanelContainer: React.FC<FeedbackPanelContainerProps> = props => {
  const handleClose = (id: string): void => {
    setSurveysCookie(id);
  };

  const surveyCookie = getSurveysCookie();

  const unansweredSurveys = props.surveys.filter(survey => !surveyCookie || !(survey.id in surveyCookie));
  const surveys = unansweredSurveys?.filter(survey => survey._type === 'survey');
  const uxSignalSurveys = unansweredSurveys?.filter(survey => survey._type === 'uxsignals');

  if (surveys?.length === 0 && uxSignalSurveys?.length === 0) {
    return null;
  }

  return (
    <div className={styles.feedbackpanelcontainer} data-testid="feedback-panel-container">
      {surveys?.map(survey => {
        if (survey.component === 'panel-static') {
          return <FeedbackPanelWrapper survey={survey} variant="static" key={survey.id} onClose={handleClose} />;
        } else if (survey.component === 'panel-expander') {
          return <FeedbackPanelWrapper survey={survey} variant="expander" key={survey.id} onClose={handleClose} />;
        }
      })}

      {uxSignalSurveys?.map(survey => {
        return <UxSignalsWrapper survey={survey} key={survey.id} />;
      })}
    </div>
  );
};

export default FeedbackPanelContainer;
